import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';
import { popularRoutes } from '../data/destinations';

const PopularRoutes = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider mb-2 block">
              {language === 'ro' ? 'Rute Populare' : 'Rotte Popolari'}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {language === 'ro' ? 'Transferuri' : 'Trasferimenti'} <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">{language === 'ro' ? 'Frecvente' : 'Frequenti'}</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto"></div>
          </div>
        </div>

        {/* Routes Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {popularRoutes.map((route, index) => (
            <Card 
              key={index}
              className="group bg-gradient-to-r from-gray-900 to-gray-950 border-gray-800 hover:border-amber-500/50 p-5 transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/10 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <p className="text-white font-semibold text-sm">
                    {language === 'ro' ? route.fromRo : route.from}
                  </p>
                  <div className="flex items-center space-x-2 my-2">
                    <div className="h-px flex-1 bg-amber-500/30"></div>
                    <ArrowRight className="w-4 h-4 text-amber-400" />
                  </div>
                  <p className="text-white font-semibold text-sm">
                    {language === 'ro' ? route.toRo : route.to}
                  </p>
                </div>
                <div className="ml-4">
                  <div className="w-10 h-10 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center group-hover:bg-amber-500 group-hover:border-amber-500 transition-all duration-300">
                    <ArrowRight className="w-5 h-5 text-amber-400 group-hover:text-black transition-colors duration-300" />
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularRoutes;
